
import {
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  INICIO_RECUPERAR_SENHA_FALHA,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  INICIO_RECUPERAR_SENHA,
  INICIO_RECUPERAR_SENHA_SUCESSO,
  RECUPERAR_SENHA,
  RECUPERAR_SENHA_SUCESSO,
  RECUPERAR_SENHA_FALHA
} from 'constants/ActionTypes';

export const iniciaRecuperarSenha = (token) => {
  return {
    type: INICIO_RECUPERAR_SENHA,
    payload: token
  }
}

export const iniciaRecuperarSenhaSucesso = (bearer)=> {
  return {
    type: INICIO_RECUPERAR_SENHA_SUCESSO,
    payload:  bearer
  }
};

export const iniciaRecuperarSenhaFalha =()=> {
  return {
    type: INICIO_RECUPERAR_SENHA_FALHA,
  }
};

export const recuperarSenhaSucesso = () => {
  return {
    type: RECUPERAR_SENHA_SUCESSO
  }
}

export const recuperarSenhaFalha = () => {
  return {
    type: RECUPERAR_SENHA_FALHA
  }
}

export const recuperarSenha = (recuperarSenhaObj) => {
  return {
    type: RECUPERAR_SENHA,
    payload: recuperarSenhaObj
  }
}

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};